export default __webpack_public_path__ + "static/media/level-platinum.b99cc0b6.svg";